import { ApiURL } from './config';

export const UmlApiUrl = `${ApiURL}/uml/svg`;
